import s from './index.module.scss';

export const BannerCard = ({ icon, title, desc, modal, onLearnMore }) => {
  return (
    <div className={s.wrapper} onClick={onLearnMore}>
      <img className={s.icon} src={icon} width={24} height={24} alt="icon" />
      <div className={s.content}>
        <div className="f-body-md f-500">{title}</div>
        <div className="f-body-sm">{desc}</div>
      </div>
      {modal}
    </div>
  );
};
